import { Injectable } from '@angular/core';
import { TeamInterface } from '../models/team.interface';
import { Permission } from '../../../shared/interfaces/permission';
import { CommonSceneLayer } from '../models/common-scene-layer';
import { AccessReason } from '../models/access-reason.enum';
import { TeamDtmsPermissions } from '../models/team-dtms-permissions';
import { TeamMapsPermissions } from '../models/team-maps-permissions';
import { TeamDataSourcePermissions } from '../interfaces/team-data-source-permissions';
import { ApplicationOptions } from '../../companies/shared/interfaces/company.interface';
import { AnchorLink } from '../../../shared/models/anchor-link';
import { TeamAnchorLinks } from '../components/teams-add/team-anchor-links';

@Injectable()
export class TeamAdapterService {
  getTeamDataForRequest(
    initialTeamData: TeamInterface,
    formValueTeamData: any,
    permissions: Permission[],
    commonSceneLayers: CommonSceneLayer[],
    applicationOptions: ApplicationOptions,
  ) {
    let team = { ...formValueTeamData };

    team = { ...team, SceneLayers: this.getSceneLayers(commonSceneLayers) };

    /*TODO ask about it on backend in future*/

    team = this.getTeamWithoutCompanySlug(team);

    team = this.getTeamWithApplicationOptions(team, applicationOptions);

    return { ...initialTeamData, ...team };
  }

  getAnchorLinks(): AnchorLink[] {
    return [
      {
        id: TeamAnchorLinks.TeamProject,
        translationKey: 'teams.generalTab.teamProjectInformation',
      },
      {
        id: TeamAnchorLinks.Note,
        translationKey: 'companies.form.CompanyNoteTitle',
      },
      {
        id: TeamAnchorLinks.TeamComponents,
        translationKey: 'teams.generalTab.components',
      },
      {
        id: TeamAnchorLinks.Security,
        translationKey: 'teams.generalTab.securityAccess',
      },
      {
        id: TeamAnchorLinks.Options,
        translationKey: 'teams.generalTab.options',
      },
      {
        id: TeamAnchorLinks.DefaultCoordinatesSystem,
        translationKey: 'companies.details.DefaultCoordinateSystem',
      },
      {
        id: TeamAnchorLinks.Api,
        translationKey: 'teams.generalTab.api',
      },
      {
        id: TeamAnchorLinks.DataCollectionAndScanning,
        translationKey: 'companies.details.DataCollectionAndScanning',
      },
      {
        id: TeamAnchorLinks.Packages,
        translationKey: 'companies.form.Packages',
      },
      {
        id: TeamAnchorLinks.Tickets,
        translationKey: 'teams.generalTab.Tickets',
      },
    ];
  }

  private getEntitiesUnderPermissionsWithoutDisabled(
    dataSources: TeamDataSourcePermissions[],
    dtms: TeamDtmsPermissions[],
    maps: TeamMapsPermissions[],
  ) {
    const filteredDataSources = dataSources.filter(ds => ds.AccessReason === AccessReason.Owner || ds.IsEnabled);
    const filteredDTMs = dtms.filter(dtm => dtm.AccessReason === AccessReason.Owner || dtm.IsEnabled);
    const filteredMaps = maps.filter(customMap => customMap.AccessReason === AccessReason.Owner || customMap.IsEnabled);
    return { DataSources: filteredDataSources, Dtms: filteredDTMs, Maps: filteredMaps };
  }

  private getSceneLayers(commonSceneLayers: CommonSceneLayer[]) {
    return commonSceneLayers
      .filter(layer => layer.isEnabled)
      .map(layer => ({
        LayerId: layer.Id,
        Name: layer.displayName || layer.Name,
        IsVisibleByDefault: layer.IsVisibleByDefault,
        IsDataCollectionEnabled: layer.IsDataCollectionEnabled,
      }));
  }

  private getTeamWithoutCompanySlug(team: TeamInterface) {
    delete team.CompanySlug;

    return team;
  }

  private getTeamWithApplicationOptions(team, applicationOptions: ApplicationOptions) {
    team.ApplicationOptions = applicationOptions;

    /*
     * DataCollectionMinAccuracy field should display at options tab on admin portal,
     *  but should send in general object on backend
     */

    if (team.ApplicationOptions.DataCollectionMinAccuracy) {
      delete applicationOptions['DataCollectionMinAccuracy'];
    }

    return team;
  }
}
